'use client';

import { useTranslations } from 'next-intl';
import { Switch } from '@/components/ui/Switch';

interface SkillContextToggleProps {
  contextName: string;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}

// Maps wire context enums to their catalog label keys under skills.skillContextToggle.
const CONTEXT_LABEL_KEYS: Record<string, string> = {
  chat: 'skillContextToggle.chat',
  standalone_chat: 'skillContextToggle.standalone',
  execution: 'skillContextToggle.execution',
  graph_program: 'skillContextToggle.graphProgram',
  post_finalization: 'skillContextToggle.postFinalization',
};

export function SkillContextToggle({
  contextName,
  enabled,
  onToggle,
}: SkillContextToggleProps) {
  const t = useTranslations('skills');
  const labelKey = CONTEXT_LABEL_KEYS[contextName];
  const label = labelKey ? t(labelKey) : contextName;
  return (
    <div className="flex items-center justify-between py-2 border-b border-border last:border-0">
      <div className="flex flex-col gap-0.5">
        <span className="text-sm font-medium">
          {label}
        </span>
        {/* TODO: Show cost/duration estimates here when credit system is implemented */}
      </div>
      <Switch checked={enabled} onCheckedChange={onToggle} aria-label={label} />
    </div>
  );
}
